import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const StyledRecentSearchContent = styled("div")`
    > ul {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        flex: 0 0 auto;
        justify-content: flex-start;
        margin: 0;
        padding: 0;
        color: ${({theme}) => theme.uxfabric.text.primary};
        @media (min-width: ${breakpoints.values.sm}px) {
            flex-direction: row;
        }

        li {
            flex: 0 0 auto;

            @media (min-width: ${breakpoints.values.sm}px) {
                flex-basis: 50%;
            }
            @media (min-width: ${breakpoints.values.md}px) {
                flex-basis: 33.3333%;
            }
            @media (min-width: ${breakpoints.values.lg}px) {
                flex-basis: 25%;
            }
        }
    }
`
